import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {

  constructor(private router: Router) {}

  ngOnInit() {
  	let links = document.getElementsByClassName('nav-link');

    let navs = ['nav-container', 'navbar-brand', 'navbar-toggler', 'navbar-collapse'];
  	
  	[].forEach.call(links, (link) => {
 			link.classList.remove('selected-text');
  	})
    
  	if (this.router.url !== '/' && this.router.url.split('/').length === 2) { // Styling Url '/classes', '/schedule', '/belt-testing', and '/team'
			document.getElementsByClassName(`${this.router.url.split('/')[1]}`)[0].classList.add('selected-text');
      
      // Navbar Link color set to black
      [].forEach.call(links, (link) => {
        link.classList.add('nav-link-main')
        link.classList.remove('nav-link-class')
      })

      // Switches Navbar styles to white background
      navs.forEach((nav) => {
        document.getElementsByClassName(`${nav}`)[0].classList.add(`${nav}-main`);
        document.getElementsByClassName(`${nav}`)[0].classList.remove(`${nav}-class`);
      })
  	} else if (this.router.url !== '/' && this.router.url.split('/').length > 2) { // Styling Url for '/classes/<Class Name>'
      // Highlights 'classes' in navbar red
      document.getElementsByClassName(`${this.router.url.split('/')[1]}`)[0].classList.add('selected-text');

      // Decorates navbar link white when unhovered and black when hovered
      [].forEach.call(links, (link) => {
        link.classList.remove('nav-link-main')
        link.classList.add('nav-link-class')
      })

      // Switches Navbar styles to black/transparent background
      navs.forEach((nav) => {
        document.getElementsByClassName(`${nav}`)[0].classList.remove(`${nav}-main`);
        document.getElementsByClassName(`${nav}`)[0].classList.add(`${nav}-class`);
      })  
    } else if (this.router.url === '/') { // Root Url '/'
      // =====================================
      // | | | On Load Navbar Animation
      // =====================================
      document.getElementsByClassName('classes-animation')[0].classList.add('reveal-animation-3');
      document.getElementsByClassName('classes-animation')[0].setAttribute('style', 'display: block;');

      document.getElementsByClassName('schedule-animation')[0].classList.add('reveal-animation-2');
      document.getElementsByClassName('schedule-animation')[0].setAttribute('style', 'display: block;');

		  document.getElementsByClassName('logo-animation')[0].classList.add('reveal-animation-1');
      document.getElementsByClassName('logo-animation')[0].setAttribute('style', 'display: block;');

      document.getElementsByClassName('private-lessons-animation')[0].classList.add('reveal-animation-2');
      document.getElementsByClassName('private-lessons-animation')[0].setAttribute('style', 'display: block;');

      document.getElementsByClassName('team-animation')[0].classList.add('reveal-animation-3');
      document.getElementsByClassName('team-animation')[0].setAttribute('style', 'display: block;');
      // =====================================

      // Navbar Link color set to black
      [].forEach.call(links, (link) => {
        link.classList.add('nav-link-main')
        link.classList.remove('nav-link-class')
      })

      // Switches Navbar styles to white background
      navs.forEach((nav) => {
        document.getElementsByClassName(`${nav}`)[0].classList.add(`${nav}-main`);
        document.getElementsByClassName(`${nav}`)[0].classList.remove(`${nav}-class`);
      })
		}
  }
}
